// Air Datepicker for Months

// jQuery document ready
$(function () {

    // If Air Datepicker defined
    if($.fn.datepicker) {

        // Months Datepicker
        $('.dp-month').datepicker({
            view: 'months',
            minView: 'months',
            dateFormat: 'mm.yyyy',
            language: 'de',
            toggleSelected: false,
            onSelect: function(formattedDate, date, inst){
                $($(inst)[0]['el']).css('color', 'black');
            }
        });
    }

    // Selectize
    $('.select-selectize').selectize();
});